import React from 'react';

// Hand-drawn accent shapes, used sparingly near section edges, image frames,
// pull quotes, and event cards. All are decorative and hidden from screen
// readers. Colors are limited to the brand shape palette.

type DoodleProps = {
  className?: string;
  color?: string;
};
const base = {
  fill: 'none',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
} as const;
export function DoodleUnderline({
  className = '',
  color = 'var(--bcm-yellow)'
}: DoodleProps) {
  return <svg viewBox="0 0 220 18" aria-hidden="true" focusable="false" className={className} data-id="element-34" data-mp="1sdfeq9sv31dp">
      <path d="M4 12c38-7 78-9 118-7 24 1 52 4 94 9" stroke={color} strokeWidth="6" {...base} data-id="element-35" data-mp="1nmqk4llvxoac" />
    </svg>;
}
export function DoodleArrow({
  className = '',
  color = 'var(--bcm-dark-blue)'
}: DoodleProps) {
  return <svg viewBox="0 0 90 70" aria-hidden="true" focusable="false" className={className} data-id="element-36" data-mp="2g3t2vp8bsg30">
      <path d="M6 8c26 6 46 22 54 46" stroke={color} strokeWidth="4" {...base} data-id="element-37" data-mp="2bb9q2uhgpoz9" />
      <path d="M44 48l17 9 3-19" stroke={color} strokeWidth="4" {...base} data-id="element-38" data-mp="3aihzkvs0xzvq" />
    </svg>;
}
export function DoodleStar({
  className = '',
  color = 'var(--bcm-pink)'
}: DoodleProps) {
  return <svg viewBox="0 0 60 60" aria-hidden="true" focusable="false" className={className} data-id="element-39" data-mp="31qzmwuuae27e">
      <path d="M30 6c2 12 10 20 22 24-12 4-20 12-22 24-2-12-10-20-22-24 12-4 20-12 22-24z" stroke={color} strokeWidth="3.5" {...base} data-id="element-40" data-mp="35rtb7pbn5j0t" />
    </svg>;
}
export function DoodleSquiggle({
  className = '',
  color = 'var(--bcm-light-blue)'
}: DoodleProps) {
  return <svg viewBox="0 0 160 40" aria-hidden="true" focusable="false" className={className} data-id="element-41" data-mp="2irvf1peheehb">
      <path d="M4 26c14-22 28 14 42-6s28 20 42 0 24 8 28 2" stroke={color} strokeWidth="5" {...base} data-id="element-42" data-mp="2mt749ttg0xoz" />
    </svg>;
}
export function DoodleCircle({
  className = '',
  color = 'var(--bcm-dark-blue)'
}: DoodleProps) {
  return <svg viewBox="0 0 240 110" aria-hidden="true" focusable="false" className={className} data-id="element-43" data-mp="l115h4dm7us7">
      <path d="M126 6C64 2 10 22 6 55c-4 32 52 51 118 49 58-2 110-22 110-50C234 26 186 9 126 6z" stroke={color} strokeWidth="4" {...base} data-id="element-44" data-mp="1u0c22qglcqqp" />
    </svg>;
}
export function DoodleBurst({
  className = '',
  color = 'var(--bcm-yellow)'
}: DoodleProps) {
  return <svg viewBox="0 0 70 70" aria-hidden="true" focusable="false" className={className} data-id="element-45" data-mp="1g0kj0bb7wk5u">
      <path d="M35 4v16M35 50v16M4 35h16M50 35h16M13 13l11 11M46 46l11 11M57 13L46 24M24 46L13 57" stroke={color} strokeWidth="4.5" {...base} data-id="element-46" data-mp="2cnyxw418491r" />
    </svg>;
}
export function DoodleHeart({
  className = '',
  color = 'var(--bcm-pink)'
}: DoodleProps) {
  return <svg viewBox="0 0 64 60" aria-hidden="true" focusable="false" className={className} data-id="element-47" data-mp="1yy3qvblxvwqo">
      <path d="M32 54C18 44 6 34 6 22 6 13 13 6 22 6c5 0 9 3 10 7 1-4 5-7 10-7 9 0 16 7 16 16 0 12-12 22-26 32z" stroke={color} strokeWidth="4" {...base} data-id="element-48" data-mp="2wd9edk8smy0x" />
    </svg>;
}
export function DoodleWave({
  className = '',
  color = 'var(--bcm-light-blue)'
}: DoodleProps) {
  return <svg viewBox="0 0 1440 60" preserveAspectRatio="none" aria-hidden="true" focusable="false" className={className} data-id="element-49" data-mp="33w8unh0yk9g2">
      <path d="M0 34c120-24 240 22 360 20s240-40 360-38 240 40 360 38 240-30 360-20" stroke={color} strokeWidth="5" {...base} data-id="element-50" data-mp="38usftf7q9h7d" />
    </svg>;
}